<!--スケジュール-->
<template>
  <div style="border: 0px solid red; height:100%" class="s0001Class">
    <!-- 标签页菜单 -->
    <vue-tabs-swiper v-model="tabsIndex" @change="tabChange" ref="tabSwiper">
      <div :tab-label="$t('MODULE.S0001_MAIN_TITTLE_TAB1')">
        <s_0001tab1  ref="s_0001tab1"></s_0001tab1>
      </div>
      <div  :tab-label="$t('MODULE.S0001_MAIN_TITTLE_TAB2')">
        <s_0001tab2  ref="s_0001tab2"></s_0001tab2>
      </div>
      <div :tab-label="$t('MODULE.S0001_MAIN_TITTLE_TAB3')">
        <s_0001tab3  ref="s_0001tab3"></s_0001tab3>
      </div>

    </vue-tabs-swiper>
  </div>
</template>
<script>
import s_0001tab1 from "./s_0001_tab1";
import s_0001tab2 from "./s_0001_tab2";
import s_0001tab3 from "./s_0001_tab3";
let url = require('@/../config/sysConfig')
export default {
  components: {
    s_0001tab1: s_0001tab1,
    s_0001tab2: s_0001tab2,
    s_0001tab3: s_0001tab3
  },
  name: "Map",
  
  data() {
    return {
      changePage:true,
      tabsIndex: 0,
      currentTabsIndex: 0,

    }
  },
  mounted() {
    // window.addEventListener("orientationchange", this.renderResize)//监控横竖屏事件
  },
  methods: {
    // renderResize() {
    //     if (window.orientation === 90 || window.orientation === -90) {
    //     // 横屏处理      
    //     } else {
    //     // 竖屏处理
    //     } 
    //     // 注意：renderResize方法执行时虚拟dom尚未渲染挂载，如果要操作vue实例，最好在this.$nextTick()里进行。
    // },
    tabChange(currentIndex, b) {
      this.currentTabsIndex = currentIndex
      //tab切换后，隐藏其他tab的内容
      if (currentIndex == 0 && this.$refs.s_0001tab1) {
        this.$refs.s_0001tab1.getTabsIndex(currentIndex)
        this.$refs.s_0001tab1.$el.hidden = false
        if (this.$refs.s_0001tab2) this.$refs.s_0001tab2.$el.hidden = true
        if (this.$refs.s_0001tab3) this.$refs.s_0001tab3.$el.hidden = true
      } else if (currentIndex == 1) {
        this.$refs.s_0001tab2.$el.hidden = false
        if (this.$refs.s_0001tab1) this.$refs.s_0001tab1.$el.hidden = true
        if (this.$refs.s_0001tab3) this.$refs.s_0001tab3.$el.hidden = true
      } else if (currentIndex == 2) {
        this.$refs.s_0001tab3.$el.hidden = false
        if (this.$refs.s_0001tab1) this.$refs.s_0001tab1.$el.hidden = true
        if (this.$refs.s_0001tab2) this.$refs.s_0001tab2.$el.hidden = true
      } else {
        //無処理
      }
    }
  },
  computed: {

  },
}

</script>
<style>
.s0001Class *:not(input, textarea) {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>


// WEBPACK FOOTER //
// src/module/page/s_0001.vue